import { IMultiAwardWinningSectionProps } from "./MultiAwardWinningSection.types";
import "./MultiAwardWinningSection.scss";

export default function MultiAwardWinningSection() {
  return (
    <div
      data-testid="MultiAwardWinningSection"
      className="multi-award-winning-section"
    >
      <div className="section-title">Multi-award winning Pet Insurance</div>
      <div className="content">
        <div className="content-title">
          Get Pet Insurance from Australia’s highest rated^ <br />and multi-award
          winning Pet Insurance Provider
        </div>
        <p className="content-description">
          FiftyUp Club Members get exclusive savings on Petsy Pet Insurance
          Premiums*
        </p>
        <p className="content-description-second">
          Continue to see your member savings. Limited time offers.
        </p>
        <div className="award-logo-wrapper">
          <img src="/images/petsy-fiftyup-awards.png" alt="Petsy-Fiftyup-Awards" className="award-image" />
          <div className="separator">
            <hr />
          </div>
          <img src="/images/petsy-fiftyup-logo.png" alt="Petsy-Fiftyup-Logo" className="brand-logo" />
        </div>
        <div className="content-footer">
          <p className="content-footer-text">
            *T&C’s apply.<br />^Highest rated as at August 2025.
          </p>
        </div>
      </div>
    </div>
  );
}
